import { defineMessages } from 'react-intl'

export default defineMessages({
  offlineStatusMessage: {
    id: 'app.offline.status.message',
    defaultMessage: 'Online status'
  },
  offlineStatusDescription: {
    id: 'app.offline.status.description',
    defaultMessage: 'You went offline'
  }
})
